import Vue from "vue";

export function getWebSocketURL() {
  let api_url = Vue.prototype.$api_url
  return `${api_url.includes("https") ? "wss" : "ws"}://${
    api_url.split("//")[1]
  }/cable`;
}
